import liff from '@line/liff';

/**
 * LIFFユーザープロファイル情報をNew Relicに記録するプラグイン
 *
 * 非ブロッキングで実行され、プロファイル取得失敗時もアプリケーションを停止しない
 */
export default defineNuxtPlugin(() => {
  const { $newrelic } = useNuxtApp();

  // New Relicが無効な場合は何もしない
  if (!$newrelic) return;

  // 非ブロッキング実行
  (async () => {
    try {
      const profile = await liff.getProfile();

      // ユーザーIDを設定（New Relic標準機能）
      $newrelic.setUserId(profile.userId);

      // 表示名をカスタム属性として記録
      $newrelic.setCustomAttribute('username', profile.displayName);
    } catch (error) {
      // LIFFプロファイル取得失敗はwarningレベル（致命的ではない）
      console.warn('[LIFF] Failed to get profile for New Relic', error);
    }
  })();
});
